module.exports = __webpack_public_path__ + "media/images/icons/apple-podcast-lg-6333ee8fc0179afc5e509db9a4ef9db6.svg";